import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormSelect, FormTextField } from 'src/components/form';
import { BasicDatePicker } from 'src/components/form/DatePicker';
import { Row, Section } from 'src/components/layout';
import { FormFields, PRONOUN_OPTIONS, SEX_OPTIONS } from 'src/constants';
import { dataTestIds } from 'src/constants/data-test-ids';
import { REQUIRED_FIELD_ERROR_MESSAGE } from 'utils';

const { patientSummary } = FormFields;

import { useTranslation } from 'react-i18next';

export const AboutPatientContainer: FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const translatedPronounOptions = PRONOUN_OPTIONS.map((option) => ({
    ...option,
    label: t(
      `patientProfile.options.pronouns.${option.value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')}`,
      option.label
    ),
  }));

  const translatedSexOptions = SEX_OPTIONS.map((option) => ({
    ...option,
    label: t(
      `patientProfile.options.sex.${option.label
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')}`,
      option.label
    ),
  }));

  return (
    <Section title={t('patientProfile.sections.patientInformation')}>
      <Row label={t('patientProfile.fields.lastName')} inputId={patientSummary.lastName.key} required>
        <FormTextField
          name={patientSummary.lastName.key}
          control={control}
          disabled={isLoading}
          InputProps={{ readOnly: true }}
          rules={{ required: REQUIRED_FIELD_ERROR_MESSAGE }}
          id={patientSummary.lastName.key}
          data-testid={dataTestIds.patientInformationContainer.patientLastName}
        />
      </Row>
      <Row label={t('patientProfile.fields.firstName')} inputId={patientSummary.firstName.key} required>
        <FormTextField
          name={patientSummary.firstName.key}
          control={control}
          disabled={isLoading}
          InputProps={{ readOnly: true }}
          rules={{ required: REQUIRED_FIELD_ERROR_MESSAGE }}
          id={patientSummary.firstName.key}
          data-testid={dataTestIds.patientInformationContainer.patientFirstName}
        />
      </Row>
      <Row label={t('patientProfile.fields.dateOfBirth')} inputId={patientSummary.birthDate.key} required>
        <BasicDatePicker
          id={patientSummary.birthDate.key}
          name={patientSummary.birthDate.key}
          control={control}
          disabled={true}
          rules={{ required: REQUIRED_FIELD_ERROR_MESSAGE }}
          dataTestId={dataTestIds.patientInformationContainer.patientDateOfBirth}
          component="Field"
        />
      </Row>
      <Row label={t('patientProfile.fields.preferredPronouns')}>
        <FormSelect
          name={patientSummary.pronouns.key}
          control={control}
          options={translatedPronounOptions}
          disabled={isLoading}
          readOnly={true}
          data-testid={dataTestIds.patientInformationContainer.patientPreferredPronouns}
        />
      </Row>
      <Row label={t('patientProfile.fields.birthSex')} required>
        <FormSelect
          name={patientSummary.birthSex.key}
          control={control}
          disabled={isLoading}
          readOnly={true}
          options={translatedSexOptions}
          rules={{
            required: REQUIRED_FIELD_ERROR_MESSAGE,
          }}
          data-testid={dataTestIds.patientInformationContainer.patientBirthSex}
        />
      </Row>
    </Section>
  );
};
